import Vue from 'vue';

// For full framework
import Vuetify from 'vuetify/lib/framework';
// For a-la-carte components - https://vuetifyjs.com/en/customization/a-la-carte/
// import Vuetify from 'vuetify/lib'

import * as directives from 'vuetify/lib/directives';
import i18n from './vue-i18n';
import config from '../configs';
/**
 * Vuetify Plugin
 * Main components library
 *
 * https://vuetifyjs.com/
 *
 */
Vue.use(Vuetify, {
  directives: directives
});
export default new Vuetify({
  rtl: config.theme.isRTL,
  theme: {
    themes: {
      light: {
        primary: '#0048cf',
        secondary: '#13abff',
        accent: '#0f2056',
        error: '#f03063',
        danger: '#0f2056'
      }
    }
  },
  lang: {
    current: config.locales.locale,
    // To use Vuetify own translations without Vue-i18n comment the next line
    t: function t(key) {
      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }
      return i18n.t(key, params);
    }
  }
});